import { connect } from "react-redux";
import { compose } from "redux";
import { createStructuredSelector } from "reselect";

import { getTeamSponsors, resetTeamSponsors } from "./actions";
import { selectIsError, selectIsReady, selectTeamSponsors } from "./reducer";
import Component from "./teamSponsors";

const mapStateToProps = createStructuredSelector({
  isReady: selectIsReady,
  isError: selectIsError,
  sponsors: selectTeamSponsors,
});

const mapDispatchToProps = (dispatch) => ({
  onGetTeamSponsors: (data) => dispatch(getTeamSponsors(data)),
  onResetTeamSponsors: (data) => dispatch(resetTeamSponsors(data)),
});

export function fetchData(store) {
  return store.dispatch(getTeamSponsors());
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(Component);
